import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function ScrollTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollBy(0, -window.innerHeight);
  }, [pathname]);

  return null;
}

export default ScrollTop;
